module.exports = __webpack_public_path__ + "img/switch-icon2.7516c8f8.svg";